var map = {
	"./Drinks/en/alcoholic.json": [
		228,
		228
	],
	"./Drinks/en/coffee.json": [
		78,
		78
	],
	"./Drinks/en/nonAlcoholic.json": [
		234,
		853
	],
	"./Drinks/mk/alcoholic.json": [
		71,
		71
	],
	"./Drinks/mk/coffee.json": [
		127,
		127
	],
	"./Drinks/mk/nonAlcoholic.json": [
		64,
		64
	],
	"./en/Hot.json": [
		313,
		313
	],
	"./en/Pizza.json": [
		980,
		980
	],
	"./en/Salads.json": [
		696,
		696
	],
	"./mk/Hot.json": [
		362,
		362
	],
	"./mk/Pizza.json": [
		691,
		691
	],
	"./mk/Salads.json": [
		209,
		209
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 399;
module.exports = webpackAsyncContext;